import React from 'react';

import Reaptcha from 'reaptcha';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

import * as recaptchaActions from '../../../actions/recaptcha/recaptchaActions';

class Recaptcha extends React.Component {
    constructor(props) {
        super(props);
        this.onVerify = this.onVerify.bind(this);
        this.onExpire = this.onExpire.bind(this);
    }


    onVerify(response) {
        this.props.persistVerification(response);
    }

    onExpire() {
        this.props.expireVerification();
    }

    render() {
        return (
            <span className="rec-recaptcha">
                <Reaptcha
                    sitekey={process.env.RECAPTCHA_SITE_KEY}
                    onVerify={this.onVerify}
                    onExpire={this.onExpire} />
            </span>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return {
        persistVerification: (verification) => dispatch(recaptchaActions.persistVerification(verification)),
        expireVerification: () => dispatch(recaptchaActions.expireVerification())
    }
}

Recaptcha.propTypes = {
    persistVerification: PropTypes.func,
    expireVerification: PropTypes.func
};

export default connect(
    (state) => ({
        verification: state.recaptcha.verification
    }),
    mapDispatchToProps
)(Recaptcha);
